import { Form, Input, Row, Col, Switch, InputNumber, Select } from 'antd';
import { useRef, useEffect, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import getList from '../../../utilsTsx/universal/getList';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';

const EditComponent = (props: any) => {
    const apiId = 'membershipLevel';
    const { defaultService } = props;
    const [form] = Form.useForm();
    const ref = useRef<any>(undefined);

    const [membershipTypeData, setMembershipTypeData] = useState<any>();
    const [membershipPointsPlansData, setMembershipPointsPlansData] = useState<any>();

    useEffect(() => {
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'membershipType',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setMembershipTypeData(res.data);
                }
            })
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'membershipPointsPlans',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setMembershipPointsPlansData(res.data);;
                }
            })
    }, []);

    const extendProps: WebEditUniversalProps = {
        ...props,
        form,
        apiId,
        serviceId: 'business',
        displayOptions: {
            width: 700
        },
        formOptions: {
            instance: form,
            children: (
                <Row gutter={[8, 0]}>
                    <Col span={12}>
                        <Form.Item
                            label="ID"
                            name="id">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="级别名"
                            name="levelName"
                            rules={[{ required: true, message: '请输入级别名!' }]}>
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="类别"
                            name="membershipTypeId"
                            rules={[{ required: true, message: '请选择类别!' }]}>
                            <Select
                                showSearch
                                placeholder="类别"
                                optionFilterProp="children"
                                filterOption={(input, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                {getList.general(membershipTypeData, { itemName: 'typeName' })}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            label="积分方案"
                            name="membershipPointsPlansId">
                            <Select
                                showSearch
                                placeholder="积分方案"
                                optionFilterProp="children"
                                filterOption={(input, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                {getList.general(membershipPointsPlansData,
                                    {
                                        itemName: 'planName',
                                        includeNull: true
                                    })}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item
                            label="进阶点"
                            name="progressionPoints"
                            tooltip='会员成长值达到则进阶'>
                            <InputNumber style={{ width: 140 }} />
                        </Form.Item>
                    </Col>

                    <Col span={7}>
                        <Form.Item
                            label="升级排序"
                            name="tieredSorting"
                            tooltip='根据每个会员类型的升级排序，0为最低级别'>
                            <InputNumber />
                        </Form.Item>
                    </Col>

                    <Col span={5}>
                        <Form.Item
                            label="状态"
                            name="isUse"
                            valuePropName="checked"
                            initialValue={true}>
                            < Switch checked={true}
                                checkedChildren="启用"
                                unCheckedChildren="关闭" />
                        </Form.Item>
                    </Col>

                </Row>
            )
        }
    };

    return (<WebEditUniversal ref={ref} {...extendProps} />)
}

export default EditComponent;